import { TwilioError } from './types';

export const twilioUndeliveredSmsError: TwilioError = {
  code: 30003,
  errorMessage:
    'The destination handset you are trying to reach is switched off or otherwise unavailable.',
};
